document.addEventListener('DOMContentLoaded',function(){
  var btn=document.querySelector('[data-menu-toggle]'),nav=document.querySelector('[data-nav]');
  if(btn&&nav){btn.addEventListener('click',function(){nav.classList.toggle('open');btn.setAttribute('aria-expanded',nav.classList.contains('open')?'true':'false')})}
});

document.addEventListener('DOMContentLoaded', function(){
  var sliders = document.querySelectorAll('[data-product-slider]');
  sliders.forEach(function(slider){
    var slides = slider.querySelectorAll('[data-product-slide]');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    var current = slider.querySelector('[data-slider-current]');
    var index = 0;

    function showSlide(newIndex){
      if(!slides.length) return;
      index = (newIndex + slides.length) % slides.length;
      slides.forEach(function(slide, i){
        slide.classList.toggle('active', i === index);
      });
      if(current) current.textContent = index + 1;
    }

    if(prev) prev.addEventListener('click', function(){ showSlide(index - 1); });
    if(next) next.addEventListener('click', function(){ showSlide(index + 1); });
    showSlide(0);
  });
});
